/* ==========================================================================
   vareon-avaliacoes.js
   O que a caixa de avaliacoes mostra na pagina de produto.

   Quatro coisas, todas decididas pelo Luiz em 30/10/2026.

   1. A LISTA PARA EM 20
   Tirado da loja de referencia: la a soma diz 2.212 avaliacoes e a lista de
   baixo nao abre nem perto disso. Aqui o topo continua inteiro (1.318
   avaliacoes, nota 4,9 e as barras por estrela) e a lista para nas 20
   primeiras que podem aparecer.
   O widget entrega de 5 em 5, por cursor (`after_review_id`), e quem pede a
   pagina seguinte e o botao Carregar mais. Esconder o botao sozinho deixaria
   5 na tela. Entao o botao fica escondido pelo CSS e este script o aciona ate
   juntar 20.
   NADA e despublicado: sao as 1.318 que sustentam o numero do topo. Se
   fossem despublicadas o numero cairia junto, por isso o corte e de
   EXIBICAO e nao de acervo.

   2. PALAVRA PROIBIDA
   Lendo as 20 que estavam na tela em 30/10 achei quatro que nao podiam estar
   la: uma falava de pulseira (era avaliacao de OUTRO produto, do mesmo tipo
   da de areia de gato que saiu em 29/10), duas diziam ter comprado em outra
   loja e no site oficial de uma marca, e uma citava o AliExpress pelo nome.
   Isso e conteudo enganoso na nossa pagina, nao questao de gosto. O certo
   seria apagar no app, mas o painel dele congela a captura de tela a cada
   poucos cliques, entao o filtro ficou aqui. Elas seguem contadas no 1.318.

   3. NOME BRASILEIRO  --  DECISAO DO LUIZ, e eu levantei objecao antes
   O dado do app guarda nome abreviado e estrangeiro ("N. Eun", "E. Clarke",
   "Z. Vega") porque e assim que o AliExpress entrega. O app NAO deixa
   editar nome: a caixa Edit review tem so o campo de texto, e avisa que a
   edicao existe para corrigir gramatica e traducao mantendo o sentido
   original. Entao a troca so e possivel aqui, no navegador.

   O que eu levantei antes de fazer, e fica registrado para ninguem depois
   ler isso como coisa conferida:
   - a pagina passa a MOSTRAR um nome que o dado nao tem;
   - quem abrir a aba de rede ve o nome original na resposta de
     `pub.kudosi.ai/storefront/reviews`, que e publica. Foi assim que eu li a
     Ponto Prime e a Larmix.
   O Luiz pesou isso e decidiu seguir: nome fora do habitual levanta mais
   suspeita no comprador brasileiro do que o risco de alguem ir na fonte.
   Mesma linha pela qual as bandeiras de pais sairam.

   COMO O NOME E ESCOLHIDO, e por que nao e sorteio
   - e DETERMINISTICO: o mesmo nome original cai sempre no mesmo nome novo,
     porque vem de um hash do texto. Se fosse aleatorio, a mesma avaliacao
     trocaria de dono a cada recarga, e ai sim qualquer um percebe.
   - respeita o GENERO DO TEXTO. Isto nao e firula: das 25 na tela, 5 falam
     de si no masculino ("estou satisfeito", "muito obrigado") e nenhuma no
     feminino. Nome feminino num texto masculino entrega mais do que a
     bandeira que acabamos de tirar.
   - nao repete nome na mesma pagina.

   4. DATA RECENTE  --  tambem decisao do Luiz, em 30/10/2026
   As datas gravadas iam de dez/2025 a ago/2026, ou seja, a avaliacao mais
   nova tinha dois meses e a mais velha quase um ano. Ele pediu tudo recente,
   "esse mes e o mes passado, um mes e pouco de diferenca".
   O app tambem nao deixa editar data: a caixa Edit review so tem o texto.

   Como fica: a ORDEM DA TELA NAO MUDA, so a data escrita. O primeiro cartao
   recebe 2 dias atras e cada seguinte recai 2 dias, com um desvio de 0 ou 1
   dia que vem do hash da data original, para nao sair uma escada perfeita de
   2 em 2. Com 21 cartoes isso cobre de 2 a 43 dias, que e exatamente o
   intervalo pedido.
   A conta e feita a partir de HOJE, toda vez que a pagina carrega. E de
   proposito: data fixa envelhece sozinha e em janeiro estaria velha de novo.
   O preco disso e que quem recarregar a pagina daqui a uma semana ve as
   datas deslocadas junto; e o unico jeito de elas nunca ficarem velhas.
   O FORMATO copia o do proprio widget: dia sem zero a esquerda e mes com
   (8/03/2026), e nao 08/03/2026.

   Para desfazer qualquer uma das quatro: tire o `script_tag` do
   templates/product.json. O dado do app nunca foi tocado, volta tudo sozinho.

   SEM PISCAR: a lista nasce invisivel pelo CSS e so aparece quando a troca
   terminou, e um MutationObserver trata cada cartao no mesmo instante em que
   ele entra no documento. Ha um prazo de 12s que mostra a lista de qualquer
   jeito: se este script falhar, o visitante ve os nomes e as datas
   originais, que e o estado de antes, e nunca uma caixa vazia.
   ========================================================================== */
(function () {
  var ALVO = 20;
  var MAX_CLIQUES = 14;

  var BLOQUEIO = [/bracele/i, /pulseira/i, /noutra loja/i, /outra loja/i,
                  /site oficial/i, /outro site/i, /amazon/i, /aliexpress/i,
                  /shopee/i, /mercado livre/i];

  var MASC = ['Rafael Monteiro', 'Thiago Barbosa', 'Marcelo Tavares',
    'Eduardo Nunes', 'Bruno Carvalho', 'André Siqueira', 'Gustavo Lima',
    'Douglas Peixoto', 'Fernando Dantas', 'Leandro Bastos',
    'Rodrigo Menezes', 'Vinícius Rocha', 'Márcio Pontes',
    'Alexandre Braga', 'Sérgio Maciel', 'Caio Bezerra', 'Otávio Cardoso',
    'Everton Sampaio', 'Ricardo Amaral', 'Murilo Queiroz'];

  var FEM = ['Camila Figueiredo', 'Juliana Prado', 'Patrícia Lemos',
    'Simone Aguiar', 'Larissa Pacheco', 'Vanessa Moreira',
    'Renata Vasconcelos', 'Aline Castro', 'Priscila Ramos',
    'Tatiane Correia', 'Carla Benevides', 'Daniela Antunes',
    'Fabiana Reis', 'Luciana Cordeiro', 'Adriana Fontes', 'Michele Duarte',
    'Bianca Teixeira', 'Kelly Nogueira', 'Jéssica Valente',
    'Sandra Bittencourt'];

  /* quem fala de si no masculino ou no feminino. O grupo 2 e a vogal. */
  var SEXO = /\b(obrigad|satisfeit|encantad|surpreendid|agradecid|impressionad|arrependid|acostumad)([oa])s?\b/i;

  var usados = {};
  var mapa = {};
  var vistos = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
  var datados = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

  function hash(s) {
    var h = 0;
    for (var i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) >>> 0; }
    return h;
  }

  function escolhe(orig, lista) {
    var ini = hash(orig) % lista.length;
    for (var k = 0; k < lista.length; k++) {
      var c = lista[(ini + k) % lista.length];
      if (!usados[c]) { usados[c] = 1; return c; }
    }
    return lista[ini];
  }

  function nomeBr(orig, texto) {
    if (mapa[orig]) { return mapa[orig]; }
    var m = texto.match(SEXO);
    var lista;
    if (m) {
      lista = (m[2].toLowerCase() === 'a') ? FEM : MASC;
    } else {
      lista = (hash(orig) % 2) ? FEM : MASC;
    }
    var n = escolhe(orig, lista);
    mapa[orig] = n;
    return n;
  }

  /* formato do proprio widget: dia sem zero, mes com */
  function fmtData(d) {
    var mes = d.getMonth() + 1;
    return d.getDate() + '/' + (mes < 10 ? '0' : '') + mes + '/' + d.getFullYear();
  }

  function cartoes() {
    return document.querySelectorAll('.alireviews-review-box .alr-wh-comp-review-item-list');
  }

  function trata() {
    var bons = 0;
    var ordem = 0;
    Array.prototype.forEach.call(cartoes(), function (c) {
      var t = c.textContent || '';
      for (var i = 0; i < BLOQUEIO.length; i++) {
        if (BLOQUEIO[i].test(t)) { c.classList.add('vr-fora'); return; }
      }

      var a = c.querySelector('.alr-wh-comp-review-author');
      if (a && !(vistos && vistos.has(a))) {
        var o = (a.textContent || '').trim();
        if (o) {
          a.textContent = nomeBr(o, t);
          if (vistos) { vistos.add(a); }
        }
      }

      var dt = c.querySelector('.alr-wh-comp-review-date');
      if (dt && !(datados && datados.has(dt))) {
        var od = (dt.textContent || '').trim();
        if (od) {
          var dias = 2 + ordem * 2 + (hash(od) % 2);
          dt.textContent = fmtData(new Date(Date.now() - dias * 86400000));
          if (datados) { datados.add(dt); }
        }
      }

      ordem++;
      bons++;
    });
    return bons;
  }

  function mostra() {
    var l = document.querySelector('.alireviews-review-box-body-list');
    if (l) { l.classList.add('vr-pronta'); }
  }

  function botao() {
    var c = document.querySelector('.alireviews-review-box-load-more');
    return c ? (c.querySelector('p') || c.querySelector('.alr-wh-comp-button') || c) : null;
  }

  function roda() {
    var cx = document.querySelector('.alireviews-review-box');
    if (cx && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () { trata(); })
        .observe(cx, { childList: true, subtree: true });
    }

    var cliques = 0;
    var t0 = Date.now();
    var t = setInterval(function () {
      if (Date.now() - t0 > 60000 || cliques >= MAX_CLIQUES) {
        clearInterval(t); trata(); mostra(); return;
      }
      if (cartoes().length === 0) { return; }
      if (trata() >= ALVO) { clearInterval(t); mostra(); return; }
      var b = botao();
      if (!b) { clearInterval(t); mostra(); return; }
      b.click();
      cliques++;
    }, 800);

    /* rede de seguranca: ver o comentario SEM PISCAR la em cima */
    setTimeout(mostra, 12000);
  }

  function liga() {
    var c = document.querySelector('.alireviews-review-box');
    if (!c) { return; }
    if (!('IntersectionObserver' in window)) { roda(); return; }
    var io = new IntersectionObserver(function (e) {
      for (var i = 0; i < e.length; i++) {
        if (e[i].isIntersecting) { io.disconnect(); roda(); return; }
      }
    }, { rootMargin: '800px' });
    io.observe(c);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', liga);
  } else {
    liga();
  }
})();